import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { getAccessToken } from '../../../../services/authService';
import LoaderSpin from '../../../Common/LoaderSpin';
import { useNavigate } from 'react-router-dom';
import { COMMERCIAL_SECTIONS, DURATION_OPTIONS, MEDIUM_OPTIONS } from '../utils/commercialTitlePage';

const inputClass = "w-full mb-2 border border-[#CACACA] p-3 py-2 text-[12px] rounded-lg bg-white"
const labelClass = "block mb-1 text-[12px] text-[#868686]"

// Commercial Title Page. Spot Title is the script's own title; the rest is saved in `commercial`. All optional.
const PageTitleModalCommercial = ({ scriptData, setIsPageTitleOpen, onSaved }) => {
    const [title, setTitle] = useState(scriptData.title || '')
    const [details, setDetails] = useState({ ...(scriptData.commercial || {}) })
    const [isLoading, setisLoading] = useState(false)
    const navigate = useNavigate()

    const setField = (key, value) => setDetails((prev) => ({ ...prev, [key]: value }))

    const updateScript = async () => {
        setisLoading(true)
        const token = getAccessToken()
        const url = `${process.env.REACT_APP_DEV_API}/document/${scriptData._id}`
        try {
            if (!token) throw new Error('A valid session not found')
            const commercial = {}
            COMMERCIAL_SECTIONS.forEach((s) => s.fields.forEach((f) => {
                const v = details[f.key]
                commercial[f.key] = v === undefined || v === null ? '' : String(v).trim()
            }))
            ;['durationCustom', 'mediumCustom'].forEach((k) => { commercial[k] = String(details[k] || '').trim() })
            if (commercial.duration !== 'Custom') commercial.durationCustom = ''
            if (commercial.medium !== 'Custom') commercial.mediumCustom = ''
            const payload = { title: title.trim(), commercial }
            const res = await fetch(url, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(payload)
            })
            const body = await res.json()
            if (!res.ok) throw new Error(body.message ? body.message : 'Error getting response')
            setisLoading(false)
            setIsPageTitleOpen(false)
            if (onSaved) onSaved(body.data || payload)
            else navigate(0)
            toast.success('Updated page title')
        } catch (error) {
            setisLoading(false)
            toast.error(error.message)
        }
    }

    const renderField = (f) => {
        const value = details[f.key] || ''
        if (f.key === 'duration' || f.key === 'medium') {
            const options = f.key === 'duration' ? DURATION_OPTIONS : MEDIUM_OPTIONS
            const customKey = `${f.key}Custom`
            return (
                <div key={f.key}>
                    <label className={labelClass}>{f.label}</label>
                    <select value={value} onChange={(e) => setField(f.key, e.target.value)} className={inputClass}>
                        <option value=''>Not specified</option>
                        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>
                    {value === 'Custom' && (
                        <input value={details[customKey] || ''} onChange={(e) => setField(customKey, e.target.value)}
                            placeholder={f.key === 'duration' ? 'e.g. 90 seconds' : 'e.g. Outdoor digital'} className={inputClass} />
                    )}
                </div>
            )
        }
        if (f.multiline) {
            return (
                <div key={f.key}>
                    <label className={labelClass}>{f.label}</label>
                    <textarea rows={3} value={value} onChange={(e) => setField(f.key, e.target.value)} className={inputClass} />
                </div>
            )
        }
        return (
            <div key={f.key}>
                <label className={labelClass}>{f.label}</label>
                <input value={value} type={f.type || 'text'} inputMode={f.type === 'tel' ? 'tel' : undefined}
                    onChange={(e) => setField(f.key, e.target.value)} className={inputClass} />
            </div>
        )
    }

    return (
        <div className='fixed top-0 left-0 h-full w-full p-4 bg-[#00000028] z-[90] flex justify-center items-center'>
            <div className='bg-white max-h-[90vh] overflow-y-auto p-4 rounded-lg w-full max-w-[560px]'>
                <h1 className='font-bold text-[#292929] mb-2 text-center'>Title Page</h1>
                <hr />
                <div className='mt-4'>
                    {COMMERCIAL_SECTIONS.map((section, i) => (
                        <div key={section.title} className={i ? 'mt-4' : ''}>
                            <p className='text-[13px] font-bold text-[#292929] mb-2'>{section.title}</p>
                            {i === 0 && (
                                <div>
                                    <label className={labelClass}>Script / Spot Title</label>
                                    <input value={title} onChange={(e) => setTitle(e.target.value)} className={inputClass} />
                                </div>
                            )}
                            {section.fields.map(renderField)}
                        </div>
                    ))}
                    <div className='mt-4 flex justify-between sticky bottom-0 bg-white pt-2'>
                        <button onClick={() => { setIsPageTitleOpen(false) }} className='w-[80px] text-[12px] border-2 text-[#868686] px-3 py-2 rounded-lg'>Cancel</button>
                        <button onClick={updateScript} className='w-[80px] text-[12px] bg-[#0099ff] text-white px-3 py-2 rounded-lg'>
                            {isLoading ? <LoaderSpin color={'white'} /> : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageTitleModalCommercial
